import dateFormat from 'dateformat';

export function formatWabikenMetaExpireDate(
  validityPeriod: number | undefined,
  notValidAfter?: number
): string {
  // 0sec = EST. we should not show expireDate
  if (!validityPeriod || validityPeriod === 0) {
    return '無期限で視聴可能';
  }

  const referenceDate = notValidAfter ? new Date(0) : new Date();
  referenceDate.setSeconds(notValidAfter ? notValidAfter : validityPeriod);

  return `${dateFormat(referenceDate, 'yyyy年m月d日 HH:MM')}まで視聴可能`;
}
